
import { Component, Prop, Watch } from 'vue-property-decorator'
import { openDialog } from '@/_components/dialog/dialog'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'

import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'
import Attachment from '@/components/Attachment/Attachment.vue'
import EditorViewer from '@/components/EditorViewer/EditorViewer.vue'
import TreeviewChip from '@/views/Project/Observation/components/treeviewChip.vue'
import ContractorInfo from './contractorInfo.vue'
import RestrictedToLabel from './labels/restrictedTo.vue'
import LocationDrawingChip from '@/views/Project/Observation/components/locationDrawingChip.vue'
import PublishDialog from '../dialogs/publish.vue'

import {
    observationIcons,
    severityColor,
    priorityColor,
    statusColor,
    dueStatusColor,
} from '@/types/observation'

@Component({
    components: {
        UserAvatar,
        Attachment,
        EditorViewer,
        TreeviewChip,
        ContractorInfo,
        RestrictedToLabel,
        PublishDialog,
        LocationDrawingChip,
    },
    mixins: [ObservationMixin],
})
export default class Card extends Mixins<MixinInterface>(ObservationMixin) {
    @Prop({ required: true }) observation!: any

    observationIcons = observationIcons
    statusColor = statusColor
    priorityColor = priorityColor
    severityColor = severityColor
    dueStatusColor = dueStatusColor

    get timeZone() {
        return this.project
            ? this.$store.getters.project(this.project.id).timeZone
            : this.guessTimezone()
    }

    // VISIBILITY
    get isDraft() {
        return this.observation?.visibility == 'private' ? true : false
    }

    get hasExtendedVisibility() {
        return this.observation?.hasExtendedVisibility
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    // PROJECT
    get project() {
        return this.observation.project.data ? this.observation.project.data : null
    }

    get categories() {
        return this.$store.getters.observationCategories
    }

    get causes() {
        return this.$store.getters.observationCauses
    }

    get locations() {
        return this.$store.getters.projectLocations
    }

    navigateToCard() {
        this.$router.push({ name: 'observation', params: { observationId: this.observation.id } })
    }

    @Watch('observation', { deep: true, immediate: true })
    cardLoaded() {
        this.$emit('cardLoaded')
    }

    // PUBLISH
    async publishObservation() {
        await openDialog(PublishDialog, {
            observation: this.observation,
        })
    }
}
